export * from './barcode-spec';
